@if (kitForm(); as kitForm) {
  <div class="flex flex-col gap-4">
    <!-- Tabs -->
    <div class="sticky top-0 z-10 -mt-1 pt-1 bg-amber-50">
      <p-buttonGroup>
        <p-button
          label="Option Setup"
          type="button"
          size="small"
          [severity]="activeTab() === 'setup' ? 'primary' : 'secondary'"
          (onClick)="activeTab.set('setup')"
        />
        <p-button
          label="Linked Options"
          [badge]="linkedViews().length.toString()"
          type="button"
          size="small"
          [severity]="activeTab() === 'linked' ? 'primary' : 'secondary'"
          (onClick)="activeTab.set('linked')"
        />
      </p-buttonGroup>
    </div>

    <!-- Option Setup -->
    <div [class.hidden]="activeTab() !== 'setup'">
      <!-- <div class="flex items-center justify-end mb-2">
        <label class="flex items-center gap-2 text-body-sm text-surface-600 cursor-pointer">
          <input
            type="checkbox"
            [checked]="applyToAllKitOptions()"
            (change)="onApplyToAllKitOptionsChange($any($event.target).checked)"
          />
          Apply to all Kit Options
        </label>
      </div> -->
      <dsm-option-config-fields
        [addendumId]="addendumId()"
        [lotId]="lotId()"
        [product]="product()"
        [form]="kitForm"
        [attributeGroups]="ownAttributes()"
        [attributesLoaded]="attributesLoaded()"
        [preloadedLocations]="parentLocations()"
        [initialAttributeValues]="kitInitialAttributeValues()"
        [submitAttempted]="submitAttempted()"
        [requireQuantity]="true"
        [requireUnitPrice]="true"
        [showCopyToLinked]="linkedViews().length > 0"
        [active]="activeTab() === 'setup'"
        (copyLocationToLinked)="onCopyLocationToLinked()"
        (copyQuantityToLinked)="onCopyQuantityToLinked()"
        (copyAttributesToLinked)="onCopyAttributesToLinked($event)"
      />
    </div>

    <!-- Linked Options -->
    <div [class.hidden]="activeTab() !== 'linked'">
      @if (linkedMissingTotal() > 0) {
        <p-message severity="error" size="small" styleClass="mb-3 w-full">
          {{ linkedMissingTotal() }} missing field{{ linkedMissingTotal() === 1 ? '' : 's' }}, configure products to add
          the kit.
        </p-message>
      }
      @if (!linkedViews().length) {
        <p class="text-body-sm text-surface-500 m-0">This kit has no linked products.</p>
      } @else {
        <div class="flex flex-col gap-3">
          @for (linked of linkedViews(); track linked.product.modelElevationProductsId) {
            <dsm-selected-product-panel
              [addendumId]="addendumId()"
              [lotId]="lotId()"
              [product]="linked.product"
              [values]="linked.values"
              [attributeGroups]="linked.attributes"
              [preloadedLocations]="linked.locations"
              [missingFieldsCount]="linked.errorCount"
              [showDeleteIcon]="false"
              [showEditIcon]="true"
              [editable]="true"
              [nested]="true"
              (edited)="onLinkedEditCommit($event, linked.index)"
            />
          }
        </div>
      }
    </div>
  </div>
}
